<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div id="user-edit-tab-info">
        <!-- Avatar Row -->
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="flex items-start flex-col sm:flex-row">
                    <!-- <img :src="data.avatar" class="mr-8 rounded h-24 w-24" /> -->
                    <!-- <vs-avatar :src="data.avatar" size="80px" class="mr-4" /> -->
                    <!-- <div>
                        <p class="text-lg font-medium mb-2 mt-4 sm:mt-0">
                            {{ data.name }}
                        </p>
                        <input
                            type="file"
                            class="hidden"
                            ref="update_avatar_input"
                            @change="update_avatar"
                            accept="image/*"
                        /> -->

                    <!-- Toggle comment of below buttons as one for actual flow & currently shown is only for demo -->
                    <!-- <vs-button class="mr-4 mb-4">Change Avatar</vs-button> -->
                    <!-- <vs-button type="border" class="mr-4" @click="$refs.update_avatar_input.click()">Change Avatar</vs-button> -->

                    <!-- <vs-button type="border" color="danger"
                            >Remove Avatar</vs-button
                        >
                    </div> -->
                </div>
            </div>
        </div>

        <!-- Content Row -->
        <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">
                <vs-input
                    class="w-full mt-4"
                    label="First Name"
                    v-model="data_local.first_name"
                    v-validate="'required|alpha_num'"
                    name="first_name"
                    tabindex="1"
                />
                <!-- <span class="text-danger text-sm"  v-show="errors.has('username')">{{ errors.first('username') }}</span> -->

                <vs-input
                    class="w-full mt-4"
                    label="Work Email"
                    v-model="data_local.email_work"
                    type="email"
                    v-validate="'required|email'"
                    name="email_work"
                    tabindex="5"
                />
                <!-- <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span> -->

                <vs-input
                    class="w-full mt-4"
                    label="Work Phone"
                    v-model="data_local.phone_work"
                    type="email"
                    v-validate="'required|alpha_num'"
                    name="phone_work"
                    tabindex="7"
                />
                <!-- <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span> -->
            </div>

            <div class="vx-col md:w-1/2 w-full">
                <div class="mt-4">
                    <vs-input
                        class="w-full mt-4"
                        label="Last Name"
                        v-model="data_local.last_name"
                        v-validate="'required|alpha_num'"
                        name="last_name"
                        tabindex="2"
                    />
                    <!-- <span class="text-danger text-sm"  v-show="errors.has('username')">{{ errors.first('username') }}</span> -->
                </div>

                <vs-input
                    class="w-full mt-4"
                    label="Personal Email"
                    v-model="data_local.email_personal"
                    type="email"
                    v-validate="'required|email'"
                    name="email_personal"
                    tabindex="6"
                />
                <!-- <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span> -->

                <vs-input
                    class="w-full mt-4"
                    label="Hand Phone"
                    v-model="data_local.phone_mobile"
                    type="email"
                    v-validate="'required|alpha_num'"
                    name="phone_mobile"
                    tabindex="8"
                />
                <!-- <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span> -->
            </div>
        </div>

        <!-- Address Row -->
        <div class="vx-row">
            <!-- Company Col -->
            <div class="vx-col w-full md:w-1/2">
                <!-- Col Header -->
                <div class="flex items-end mt-base">
                    <feather-icon
                        icon="BriefcaseIcon"
                        class="mr-2"
                        svgClasses="w-5 h-5"
                    />
                    <span class="leading-none font-medium">Company</span>
                </div>

                <!-- Col Content -->
                <div>
                    <vs-input
                        class="w-full mt-4"
                        label="Website"
                        v-model="data_local.website"
                        v-validate="'required|alpha'"
                        name="country"
                        tabindex="9"
                    />
                    <vs-input
                        class="w-full mt-4"
                        label="Company Name"
                        v-model="data_local.company"
                        v-validate="'required'"
                        name="addd_line_1"
                        tabindex="10"
                    />
                    <!-- <span
                        class="text-danger text-sm"
                        v-show="errors.has('addd_line_1')"
                        >{{ errors.first("addd_line_1") }}</span
                    > -->

                    <vs-input
                        class="w-full mt-4"
                        label="Credentials"
                        v-model="data_local.credentials"
                        name="credentials"
                    />

                    <vs-input
                        class="w-full mt-4"
                        label="Role"
                        v-model="data_local.role_in_company"
                        v-validate="'required'"
                        name="role_in_organization"
                        tabindex="11"
                    />

                    <vs-input
                        class="w-full mt-4"
                        label="Department"
                        v-model="data_local.department"
                        v-validate="'required'"
                        name="department"
                        tabindex="12"
                    />
                    <!-- <span
                        class="text-danger text-sm"
                        v-show="errors.has('post_code')"
                        >{{ errors.first("post_code") }}</span
                    > -->
                    <!-- <span
                        class="text-danger text-sm"
                        v-show="errors.has('country')"
                        >{{ errors.first("country") }}</span
                    > -->
                </div>
            </div>
            <!-- Address Col -->
            <div class="vx-col w-full md:w-1/2">
                <!-- Col Header -->
                <div class="flex items-end mt-base">
                    <feather-icon
                        icon="MapPinIcon"
                        class="mr-2"
                        svgClasses="w-5 h-5"
                    />
                    <span class="leading-none font-medium">Address</span>
                </div>

                <!-- Col Content -->
                <div>
                    <vs-input
                        class="w-full mt-4"
                        label="Road Name"
                        v-model="data_local.address_line_1"
                        v-validate="'required'"
                        name="addd_line_1"
                        tabindex="12"
                    />
                    <!-- <span
                        class="text-danger text-sm"
                        v-show="errors.has('addd_line_1')"
                        >{{ errors.first("addd_line_1") }}</span
                    > -->

                    <vs-input
                        class="w-full mt-4"
                        label="Postal Code"
                        v-model="data_local.address_postal"
                        v-validate="'required|numeric'"
                        name="post_code"
                        tabindex="13"
                    />
                    <!-- <span
                        class="text-danger text-sm"
                        v-show="errors.has('post_code')"
                        >{{ errors.first("post_code") }}</span
                    > -->

                    <vs-input
                        class="w-full mt-4"
                        label="Country"
                        v-model="data_local.address_country"
                        v-validate="'required|alpha'"
                        name="country"
                        tabindex="14"
                    />
                    <!-- <span
                        class="text-danger text-sm"
                        v-show="errors.has('country')"
                        >{{ errors.first("country") }}</span
                    > -->
                </div>
            </div>
        </div>

        <!-- Save & Reset Button -->
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="mt-8 flex flex-wrap items-center justify-end">
                    <vs-button
                        class="ml-auto mt-2"
                        @click="save_changes"
                        :disabled="!validateForm"
                        >Save Changes</vs-button
                    >
                    <vs-button
                        class="ml-4 mt-2"
                        type="border"
                        color="warning"
                        @click="reset_data"
                        >Reset</vs-button
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from "vue-select";

// Store Module
import moduleUserManagement from "@/store/user-management/moduleUserManagement.js";

export default {
    components: {
        vSelect,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            data_local: JSON.parse(JSON.stringify(this.data)),

            statusOptions: [
                { label: "Active", value: 1 },
                { label: "Deactivated", value: 0 },
            ],
            roleOptions: [
                { label: "Admin", value: "admin" },
                { label: "User", value: "user" },
                { label: "Staff", value: "staff" },
            ],
        };
    },
    computed: {
        validateForm() {
            return true;
            // return !this.errors.any();
        },
    },
    methods: {
        capitalize(str) {
            return str;
            // return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
        },
        save_changes() {
            /* eslint-disable */
            if (!this.validateForm) return;

            // Here will go your API call for updating data
            // You can get data in "this.data_local"

            /* eslint-enable */

            this.$store
                .dispatch("userManagement/addUser", this.data_local)
                .then((res) => {
                    this.$vs.notify({
                        title: "Success",
                        text: "New contact created successfully",
                        iconPack: "feather",
                        icon: "icon-check-circle",
                        color: "success",
                    });
                })
                .then(() => {
                    this.$router.push({ path: "/" });
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        reset_data() {
            this.data_local = JSON.parse(JSON.stringify(this.data));
        },
        update_avatar() {
            // You can update avatar Here
            // For reference you can check dataList example
            // We haven't integrated it here, because data isn't saved in DB
        },
    },
};
</script>
